<template>
    <vx-card :title='$t("ClientTimeOverview")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="500" search :data="overview">

            <div slot="header" class="mb-6">

                <div style="float: left" class="mr-6">
                    <p class="mt-6">{{$t("StartTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportStartTime"></flat-pickr>
                </div>

                <div style="float: left" class="mr-6">
                    <p class="mt-6">{{$t("EndTime")}}</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="reportEndTime"></flat-pickr>
                </div>

                <div style="float: left">
                    <br>
                    <vs-button class="mt-6 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" @click="addClientPrompt = true">{{$t("Add")}}</vs-button>
                    <vs-button class="mt-6 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-file-text" type="border" id="previewExcelButton" @click="generateExcel">{{$t("GenerateExcel")}}</vs-button>
                    <vs-button class="mt-6" style="float: left" color="success" icon-pack="feather" icon="icon-book" type="border" id="previewPDFButton" @click="generatePreview">{{$t("GeneratePDF")}}</vs-button>
                </div>


            </div>

            <template slot="thead">
                <vs-th sort-key="client">{{$t("Client")}}</vs-th>
                <vs-th sort-key="contract_hours">{{$t("ContractHours")}}</vs-th>
                <vs-th sort-key="worked_hours">{{$t("FinishedHours")}}</vs-th>
                <vs-th sort-key="difference_worked">{{$t("DifferenceWorked")}}</vs-th>
                <vs-th sort-key="confirmed_hours">{{$t("ConfirmedHours")}}</vs-th>
                <vs-th sort-key="difference_confirmed">{{$t("DifferenceConfirmed")}}</vs-th>
                <vs-th sort-key="comment">{{$t("Comment")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].client">
                        {{ data[index].client }}
                    </vs-td>

                    <vs-td :data="data[index].contract_hours">
                        {{ data[index].contract_hours }}
                    </vs-td>

                    <vs-td :data="data[index].worked_hours">
                        {{ data[index].worked_hours }}
                    </vs-td>

                    <vs-td :data="data[index].difference_worked">
                        {{ data[index].difference_worked }}
                    </vs-td>

                    <vs-td :data="data[index].confirmed_hours">
                        {{ data[index].confirmed_hours }}
                    </vs-td>

                    <vs-td :data="data[index].difference_confirmed">
                        {{ data[index].difference_confirmed }}
                    </vs-td>

                    <vs-td :data="data[index].comment">
                        {{ data[index].comment }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addClientPrompt">
            <div>
                <p class="mt-6">{{$t("Client")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="addClient['id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.selectableClients" />
                </vs-select>
                <p class="mt-6">{{$t("Comment")}}</p>
                <vs-input v-model="addClient['comment']" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addClientToOverview">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editClientPrompt">
            <div>
                <p class="mt-6">{{$t("Comment")}}</p>
                <vs-input v-model="editClient['comment']" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editClientComment">{{$t("Change")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeClient">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        data() {
            return {
                selected: {},
                overview: [],
                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                reportStartTime: null,
                reportEndTime: null,

                addClientPrompt: false,
                editClientPrompt: false,

                loadable: false,

                selectableClients: [],

                addClient: {},
                editClient: {},
            }
        },
        methods: {
            handleSelected(tr) {
                this.editClient['id'] = tr.client_company_id;
                this.editClient['comment'] = tr.comment;
                this.editClientPrompt = true;
            },
            updateHours() {
                if(!this.loadable) return;
                const thisIns = this;
                this.$http.post('/api/v1/company/client/timeOverview', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').format(),
                    }).then(function (response) {
                        thisIns.overview = response.data;

                        let addedClientsList = [];
                        for(let x = 0; x < thisIns.overview.length; x++){
                            addedClientsList.push(thisIns.overview[x].client_company_id)
                        }

                        thisIns.selectableClients = [];
                        for (let key in thisIns.$store.state.companyClients) {
                            if (thisIns.$store.state.companyClients.hasOwnProperty(key)) {
                                if(!addedClientsList.includes(Number(key))) {
                                    thisIns.selectableClients.push(thisIns.$store.state.companyClients[key]);
                                }
                            }
                        }

                        if(thisIns.selectableClients.length > 0) {
                            thisIns.addClient['id'] = thisIns.selectableClients[0].id;
                        }


                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addClientToOverview() {
                console.log(this.selectableClients);
                const thisIns = this;
                this.$http.put('/api/v1/company/client/timeOverview/' + this.addClient['id'], {
                    comment: this.addClient['comment'],
                }).then(function () {
                    thisIns.updateHours();
                    thisIns.addClientPrompt = false;
                })
                    .catch(function (error) {
                        thisIns.addClientPrompt = false;
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editClientComment() {
                const thisIns = this;
                this.$http.put('/api/v1/company/client/timeOverview/' + this.editClient['id'], {
                    comment: this.editClient['comment'],
                }).then(function () {
                    thisIns.updateHours();
                    thisIns.editClientPrompt = false;
                })
                    .catch(function (error) {
                        thisIns.editClientPrompt = false;
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeClient() {
                const thisIns = this;
                this.$http.delete('/api/v1/company/client/timeOverview/' + this.editClient['id']).then(function () {
                    thisIns.updateHours();
                    thisIns.editClientPrompt = false;
                })
                    .catch(function (error) {
                        thisIns.editClientPrompt = false;
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            generatePreview(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#previewPDFButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.post('/api/v1/company/client/timeOverviewPDF', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').format(),
                })
                    .then(function (response) {
                        thisIns.$vs.loading.close("#previewPDFButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = "/pdf/client_overview/" + response.data;
                        }else{
                            window.open("/pdf/client_overview/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#previewPDFButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            generateExcel(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#previewExcelButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.post('/api/v1/company/client/timeOverviewExcel', {
                    start_time: thisIns.moment(thisIns.reportStartTime).format(),
                    end_time: thisIns.moment(thisIns.reportEndTime).add(1, 'd').format(),
                })
                    .then(function (response) {
                        thisIns.$vs.loading.close("#previewExcelButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = "/api/v1/company/client/timeOverviewExcel/" + response.data;
                        }else{
                            window.open("/api/v1/company/client/timeOverviewExcel/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#previewExcelButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        watch: {
            reportStartTime: function () {
                this.updateHours()
            },
            reportEndTime: function () {
                this.updateHours()
            },
            editClientPrompt: function () {
                if(!this.editClientPrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            let currentTime = new Date();
            this.reportEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), this.moment(currentTime).daysInMonth());
            this.reportStartTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), 1);
            this.$nextTick(() => {
                this.loadable = true;
                this.updateHours();
            });
        },
    }
</script>
